// Build metadata emitted into build/version.json at build time (see
// scripts/build.js → writeVersionFile). Used both to display the deployed
// version in Settings and to detect when a newer build is live on the server.

export type BuildInfo = {
  version: string;
  commit: string;
  buildNumber: string;
  branch: string;
  /** ISO timestamp captured at build time */
  buildTime: string;
};

export async function fetchBuildInfo(): Promise<BuildInfo | null> {
  try {
    // nginx serves *.json with no-store; the query param defeats any proxy cache.
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return null;
    return (await res.json()) as BuildInfo;
  } catch {
    return null;
  }
}

/** Stable key identifying a deployed build — changes on every build. */
export const buildKey = (info: BuildInfo): string => info.buildTime || info.commit;
